import { defineStore } from 'pinia';
import { useLocalStorage } from '@vueuse/core';

export const useSidebarStore = defineStore('sidebar', () => {
  const LOCAL_STORAGE_KEY = 'GA_SIDEBAR_COMPACT';
  const compact = useLocalStorage(LOCAL_STORAGE_KEY, false);

  const toggleSideBar = () => {
    compact.value = !compact.value;
  };

  const setCompact = (isCompact: boolean) => {
    compact.value = isCompact;
  };

  return { compact, toggleSideBar, setCompact };
});
